<template>
  <!-- Navbar -->
  <nav class="navbar navbar-expand-lg bg-body-tertiary mb-5"> <!-- p-0 -->
    <div class="container">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03"
        aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!-- <a class="navbar-brand p-0" href="#">
        <img id="logo" class="navbar-img" src="../assets/logo.png" alt="Logo" draggable="false" />
      </a> -->
      <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
        <ul class="navbar-nav mx-auto mb-2 mb-lg-0" v-if="this.$route.fullPath.split('/')[1] == 'admin'">
          <li class="nav-item">
            <router-link class="nav-link" v-if="isLogedIn()  && (getUser?.privs.includes('accept') || getUser?.privs.includes('search')) " active-class="active" to="/admin/applicantsearch/"> طلبات المتقدمين
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" v-if=" !isLogedIn() " active-class="active" to="/admin/login/"> دخول الأعضاء </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" v-if="isLogedIn()  && (getUser?.privs.includes('addPrivilege') || getUser?.privs.includes('reports')) " active-class="active" to="/admin/dashboard"> لوحة التحكم </router-link>
          </li>
          <li class="nav-item dropdown" v-if="isLogedIn() &&  getUser?.privs.includes('reports') ">
            <a class="nav-link fw-semibold dropdown-toggle" href="#" id="navbarDropdown" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
               التقارير
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <li>
                <router-link class="dropdown-item p-2" to="/admin/reports/generalreport"> تقارير عامة </router-link>
              </li>
              <li>
                <router-link class="dropdown-item p-2" to="/admin/reports/illegalsreport"> المركبات المخالفة </router-link>
              </li>
              <li>
                <router-link class="dropdown-item p-2" to="/admin/reports/financialreport"> التقارير المالية </router-link>
              </li>
            </ul>
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link" active-class="active" to="/admin/profile/"> حسابي </router-link>
          </li> -->
        </ul>
        <ul class="navbar-nav mx-auto mb-2 mb-lg-0" v-else>
          <!-- <li class="nav-item">
             <router-link class="nav-link" active-class="active" to="/">{{ $t("home") }}</router-link>
          </li> -->
          <li class="nav-item">
            <router-link class="nav-link" active-class="active" to="/">{{ $t("sign") }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" active-class="active" to="/about">{{ $t("about") }}</router-link>
          </li>
        </ul>
        <ul v-if="this.$route.fullPath.split('/')[1] == 'admin' && isLogedIn()"
          class="navbar-nav py-2 ms-auto">
          <li class="nav-item dropdown">
            <a class="nav-link fw-semibold dropdown-toggle" href="#" id="navbarDropdown" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              <font-awesome-icon :icon="['fas', 'user']" /> {{getUser.firstName}}
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <li>
                <router-link class="dropdown-item p-2" to="/admin/profile/"> حسابي </router-link>
              </li>
              <li>
                <a class="dropdown-item p-2 pb-lg-3 link link-dark" @click="logout">تسجيل الخروج</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- Navbar -->

</template>
<script>

import { mapGetters } from 'vuex';
export default {
  
  name: "NavHeader",
  // data(){
    // return {
      // firstName:  sessionStorage.getItem("first_name"),
    // }
  // },
  computed:{
    
    ...mapGetters(['getUser'])
  },
  async created() {
      if(location.pathname.split('/')[1] == 'admin'){
        await this.fetchUser();
      }
    },
  methods: {
    /** */
    async fetchUser() {
      if (this.getUser.hasOwnProperty("empNo") == 0) {
        await this.$store.dispatch('fetchUser'); // Fetch and store in Vuex
      }
    },
    /********************************/
    isLogedIn(){
      return (sessionStorage.getItem("sess_exp") > Date.now()) ? true : false
    },
    /** */
    async logout() {
      try {
        const response = await this.$axios.post(`api/employee/user/logout`)
        if (response?.data.isSuccess) {
          this.$tempAlert(response.data.msg ?? "تم تسجيل الخروج", 'success');
          sessionStorage.clear()
          this.$store.commit("setUser", {privs: []})
          setTimeout(()=>{
            this.$router.push({ name: "AdminLogin" });
          },200)
        } else {
          this.$tempAlert(response?.data.msg ?? "حدثت مشكلة", 'warning');
        }
      } catch (error) {
        if (error.response?.data) {
          this.$tempAlert(error.response.data.msg ?? "مشكلة في الاتصال بالخادم", 'danger');
        }
        console.error("Error fetching options:", error);
      }
    },
    /********************************/
  }
}
</script>
<style>
.navbar-brand .navbar-img {
  height: 10vh;
}
</style>